// extracted by mini-css-extract-plugin
export default {"header":"Header_header__CEQnq","main-image":"Header_main-image__7vfTs"};